// Video Carousel - Complete Working Solution
$(document).ready(function(){
  console.log('🎬 Video Carousel: Loading...');

  $('.video-carousel__container').each(function() {
    var $slider = $(this);
    var sliderId = $slider.attr('id');
    
    console.log('✅ Found carousel:', sliderId);

    var $parent = $slider.closest('.video-carousel-block');
    var $prevArrow = $parent.find('.video-carousel__arrow--prev');
    var $nextArrow = $parent.find('.video-carousel__arrow--next');
    var $dots = $parent.find('.video-carousel__dots');

    // Count slides
    var slideCount = $slider.find('.video-carousel__slide').length;
    console.log('📹 Slides found:', slideCount);

    if (slideCount === 0) {
      console.warn('⚠️ No slides found, skipping');
      return;
    }

    // Initialize Slick
    $slider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      dots: true,
      arrows: true,
      autoplay: false,
      draggable: true,
      swipe: true,
      touchMove: true,
      speed: 500,
      cssEase: 'ease',
      prevArrow: $prevArrow,
      nextArrow: $nextArrow,
      appendDots: $dots,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2.2,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: true
          }
        }
      ]
    });

    console.log('✅ Slick initialized with infinite loop');

    // Pause videos on slide change
    $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      $slider.find('video').each(function() {
        if (!this.paused) {
          this.pause();
          this.removeAttribute('controls');
          $(this).closest('.video-carousel__video-wrapper').removeClass('video-playing');
        }
      });
    });
  });

  console.log('✅ All carousels ready');
});

// Video play/pause controls
document.addEventListener("DOMContentLoaded", function() {
  console.log('🎬 Setting up video controls...');

  var videoWrappers = document.querySelectorAll('.video-carousel__video-wrapper');
  console.log('📹 Video wrappers found:', videoWrappers.length);

  videoWrappers.forEach(function(wrapper, index) {
    var video = wrapper.querySelector('video');
    var playBtn = wrapper.querySelector('.video-carousel__play-btn');

    if (!video) {
      console.warn('⚠️ No video in wrapper', index);
      return;
    }

    if (!playBtn) {
      console.log('ℹ️ No play button for video', index, '(autoplay?)');
      return;
    }

    console.log('✅ Setting up video', index);

    // Play button click
    playBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      console.log('▶️ Play clicked for video', index);

      // Pause all other videos
      document.querySelectorAll('.video-carousel__video-wrapper').forEach(function(w) {
        var v = w.querySelector('video');
        if (v && v !== video && !v.paused) {
          v.pause();
          v.removeAttribute('controls');
          w.classList.remove('video-playing');
        }
      });

      // Play current video
      video.removeAttribute('hidden');
      video.controls = true;
      
      var playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.then(function() {
          wrapper.classList.add('video-playing');
          console.log('✅ Video', index, 'playing');
        }).catch(function(error) {
          console.error('❌ Play failed:', error);
          video.controls = false;
        });
      }
    });

    // Video pause
    video.addEventListener('pause', function() {
      wrapper.classList.remove('video-playing');
      if (!video.hasAttribute('autoplay')) {
        video.controls = false;
      }
    });

    // Video ended
    video.addEventListener('ended', function() {
      wrapper.classList.remove('video-playing');
      video.controls = false;
      video.load();
    });
  });

  console.log('✅ Video controls ready');
});
